const ICTDistrictType = {
    113: 'jerusalem',
    132: 'south',
    136: 'telAviv',
    140: 'center',
    144: 'haifa',
    148: 'north',
    167: 'educationResidency',
    168: 'jerusalemCity',
    329: 'hardy',
    410: 'workZaroa',
}
export default ICTDistrictType;